<template>
  <div>
    <div>
      <el-form :inline="true" :model="searchParams" class="demo-form-inline">
        <el-form-item label="选择数据">
          <el-select size="small" v-model="searchParams.number" placeholder="请选择数据"><el-option
              v-for="(item, index) in allLength" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
          <el-button plain size="small" @click="blowUp">恢复画布</el-button>
          <el-button plain size="small" @click="minification">缩小画布</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="canvas">
      <h3>轨迹展示------擦拭次数：{{ motionCount }}</h3>
      <canvas ref="canvas" width="3500" height="3500" style="border: 1px solid #000"></canvas>
    </div>
  </div>
</template>

<script>
import { getGyroscope, getLength } from "../../api/gyroscope";
export default {
  data() {
    return {
      searchParams: {
        number: 1,
      },
      allLength: [],
      trajectory: [],
      trajectory2: [],
      canvasCtx: null,
      pre: "",
      count: 1,
      scaleRatio: 1,
      motionCount: 0,
    };
  },
  mounted() {
    this.canvasCtx = this.$refs.canvas.getContext("2d");
    this.getData();
    this.getAllLength();
  },
  methods: {
    onSubmit() {
      this.trajectory = [];
      this.trajectory2 = [];
      this.getData();
    },
    getAllLength() {
      getLength().then((res) => {
        for (let i = 1; i <= Number(res.data[0].length); i++) {
          this.allLength.push(i);
        }
      });
    },
    getData() {
      getGyroscope(this.searchParams).then((res) => {
        for (let i = 0; i < res.data[0].x.split(",").length; i++) {
          const x = res.data[0].x.split(",")[i];
          const y = res.data[0].y.split(",")[i];
          const z = res.data[0].z.split(",")[i];
          this.trajectory.push({ x: x, y: y, z: z });
        }
        //展示移动方向、轨迹
        this.handleDeviceMotion(this.trajectory);

        // 测试数据
        // 计算运动次数
        this.motionCount = this.calculateMotionCount(this.trajectory, 152); // 阈值设为 152 cm/s²
        console.log(`Motion Count: ${this.motionCount}`); // 输出: Motion Count: 3
      });
    },
    calculateMotionCount(dataArray, threshold = 100) {
      let motionCount = 0;
      let previousValue = this.calculateMagnitude(dataArray[0]) - 1000; //dataArray[0].magnitude; // 初始化前一个值
      let isPeak = false;

      for (let i = 1; i < dataArray.length - 1; i++) {
        const currentValue = this.calculateMagnitude(dataArray[i]) - 1000; // dataArray[i].magnitude;
        const nextValue = this.calculateMagnitude(dataArray[i + 1]) - 1000; //dataArray[i + 1].magnitude;

        // 检测峰值
        if (
          currentValue > threshold &&
          currentValue > previousValue &&
          currentValue > nextValue
        ) {
          if (!isPeak) {
            motionCount++;
            isPeak = true; // 标记已检测到峰值
          }
        } else {
          isPeak = false; // 重置标记
        }

        previousValue = currentValue; // 更新前一个值
      }

      return motionCount;
    },
    calculateMagnitude(data) {
      return Math.sqrt(data.x * data.x + data.y * data.y + data.z * data.z);
    },
    handleDeviceMotion(data) {
      for (let i = 0; i < data.length; i++) {
        const threshold = 1; // 设置阈值来判断显著移动
        const x = data[i].x;
        const y = data[i].y;

        let direction = "";
        if (Math.abs(x) > threshold && Math.abs(y) > threshold) {
          if (x > 0 && y < 0) direction = "左上";
          else if (x > 0 && y > 0) direction = "左下";
          else if (x < 0 && y < 0) direction = "右上";
          else if (x < 0 && y > 0) direction = "右下";

          this.trajectory2.push(direction);
          this.drawTrajectory();
        }
      }
      this.count = 1;
      this.pre = this.trajectory2[0];
      for (let i = 0; i < this.trajectory2.length; i++) {
        if (this.trajectory2[i] != this.pre) {
          this.pre = this.trajectory2[i];
          this.count += 1;
        }
      }
    },
    drawTrajectory() {
      this.canvasCtx.clearRect(0, 0, 3500, 3500); // 清除画布
      let lastPoint = { x: 1750, y: 1750 }; // 起点位于中心

      this.trajectory2.forEach((dir) => {
        let nextPoint = { ...lastPoint };
        switch (dir) {
          case "左上":
            nextPoint.x -= 10;
            nextPoint.y -= 10;
            break;
          case "左下":
            nextPoint.x -= 10;
            nextPoint.y += 10;
            break;
          case "右上":
            nextPoint.x += 10;
            nextPoint.y -= 10;
            break;
          case "右下":
            nextPoint.x += 10;
            nextPoint.y += 10;
            break;
        }
        this.canvasCtx.beginPath();
        this.canvasCtx.moveTo(lastPoint.x, lastPoint.y);
        this.canvasCtx.lineTo(nextPoint.x, nextPoint.y);
        this.canvasCtx.stroke();
        lastPoint = nextPoint;
      });
    },
    blowUp() {
      const canvas = this.$refs.canvas;
      this.scaleRatio = 1;
      // 计算新的尺寸
      const newWidth = 3500 * this.scaleRatio;
      const newHeight = 3500 * this.scaleRatio;

      // 设置Canvas的绘图表面尺寸
      canvas.width = newWidth;
      canvas.height = newHeight;

      // 获取绘图上下文并进行缩放
      const ctx = canvas.getContext("2d");

      // 应用缩放
      ctx.scale(this.scaleRatio, this.scaleRatio);
      // 这里的坐标和大小是基于原始尺寸的
      this.canvasCtx.clearRect(0, 0, 3500, 3500); // 清除画布
      let lastPoint = { x: 1750, y: 1750 }; // 起点位于中心

      this.trajectory2.forEach((dir) => {
        let nextPoint = { ...lastPoint };
        switch (dir) {
          case "左上":
            nextPoint.x -= 10;
            nextPoint.y -= 10;
            break;
          case "左下":
            nextPoint.x -= 10;
            nextPoint.y += 10;
            break;
          case "右上":
            nextPoint.x += 10;
            nextPoint.y -= 10;
            break;
          case "右下":
            nextPoint.x += 10;
            nextPoint.y += 10;
            break;
        }
        this.canvasCtx.beginPath();
        this.canvasCtx.moveTo(lastPoint.x, lastPoint.y);
        this.canvasCtx.lineTo(nextPoint.x, nextPoint.y);
        this.canvasCtx.stroke();
        lastPoint = nextPoint;
      });
    },
    minification() {
      const canvas = this.$refs.canvas;
      this.scaleRatio -= 0.25;
      // 计算新的尺寸
      const newWidth = canvas.width * this.scaleRatio;
      const newHeight = canvas.height * this.scaleRatio;

      // 设置Canvas的绘图表面尺寸
      canvas.width = newWidth;
      canvas.height = newHeight;

      // 获取绘图上下文并进行缩放
      const ctx = canvas.getContext("2d");

      // 应用缩放
      ctx.scale(this.scaleRatio, this.scaleRatio);

      // 绘制内容
      this.drawContentMinification();
    },
    drawContentMinification() {
      // 这里的坐标和大小是基于原始尺寸的
      this.canvasCtx.clearRect(0, 0, 3500 * 0.5, 3500 * 0.5); // 清除画布
      let lastPoint = { x: 1750 * 0.5, y: 1750 * 0.5 }; // 起点位于中心

      this.trajectory2.forEach((dir) => {
        let nextPoint = { ...lastPoint };
        switch (dir) {
          case "左上":
            nextPoint.x -= 10;
            nextPoint.y -= 10;
            break;
          case "左下":
            nextPoint.x -= 10;
            nextPoint.y += 10;
            break;
          case "右上":
            nextPoint.x += 10;
            nextPoint.y -= 10;
            break;
          case "右下":
            nextPoint.x += 10;
            nextPoint.y += 10;
            break;
        }
        this.canvasCtx.beginPath();
        this.canvasCtx.moveTo(lastPoint.x, lastPoint.y);
        this.canvasCtx.lineTo(nextPoint.x, nextPoint.y);
        this.canvasCtx.stroke();
        lastPoint = nextPoint;
      });
    },
  },
};
</script>

<style scoped>
.canvas {
  margin-top: -30px;
}
</style>



// WEBPACK FOOTER //
// src/views/goods/gyroscope.vue